import o from "styled-components";
const s = o.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`, i = o.div`
  display: grid;
  gap: 6px;
  grid-template-columns: ${({ $length: t }) => `repeat(${t}, 1fr)`};
`, r = o.div`
  position: relative;
  ${({ $isSuccess: t }) => t && `
    input {
      color: transparent;
    }
  `}
`, p = o.div`
  align-items: center;
  color: ${({ theme: t }) => t == null ? void 0 : t.get("tokens.colors.success.50")};
  display: flex;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;
export {
  r as InputWrapper,
  i as InputsContainer,
  s as OTPInputContainer,
  p as SuccessIcon
};
